<template>
  <div>
    <div class="title" @click="showCommunityPicker = true">
      {{ communityName }}<van-icon name="arrow-down" />
    </div>
    <van-popup v-model="showCommunityPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="communityColumns"
        @confirm="onCommunityConfirm"
        @cancel="showCommunityPicker = false"
      />
    </van-popup>
    <div class="search">
      <van-search
        v-model="personParams.personneName"
        label="姓名"
        @search="onSearchName"
      />
      <van-search
        v-model="personParams.personneCardNo"
        label="身份证号"
        @search="onSearchCard"
      />
    </div>
    <div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-swipe-cell
          v-for="(item, index) in personList"
          :index="index"
          :key="item.id"
        >
          <van-card
            :desc="item.personneCardNo"
            :title="item.personneName"
            :thumb="url + item.showPhotoUrl + '?access_token=' + token"
          />
          <template #right>
            <van-button
              square
              type="info"
              text="重新下发"
              @click="putSyncData(item.id)"
            />
            <van-button
              square
              type="warning"
              text="下发记录"
              @click="gotoPutSyncData(item.id)"
            />
            <van-button
              square
              type="primary"
              text="编辑"
              @click="editPerson(item.id)"
            />
            <van-button
              square
              type="danger"
              text="删除"
              @click="deletePerson(item, index)"
            />
          </template>
        </van-swipe-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  /* eslint-disable */
  data() {
    return {
      communityName: "",
      communityColumns: [],
      showCommunityPicker: false,
      villageParams: {}, // 获取小区
      personParams: {
        communityId: null,
        queryType: 4,
        page: 1,
        pageSize: 10,
      },
      personList: [],
      loading: false,
      finished: false,
      url: this.$common.urlImage,
      token: null,
      access_token: null,
    };
  },
  created() {
    let token = null;
    let access_token = null;
    var query = window.location.hash.substring(1).split("?")[1];
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == "token") {
        token = pair[1].replace(/Bearer%20/g, "");
        access_token = pair[1].replace(/%20/g, " ");
      }
    }
    localStorage.setItem("token", token);
    this.token = token;
    this.access_token = access_token;
  },
  methods: {
    onLoad() {
      let that = this;
      if (this.personParams.communityId) {
        this.getPersonList();
      } else {
        that
          .post("api-apmuc/communityRest/queryCommunitys", that.villageParams)
          .then((res) => {
            that.communityColumns = res.data;
            that.communityName = res.data[0].xqmc;
            that.personParams.communityId = res.data[0].id;
            this.getPersonList();
          });
      }
    },
    getPersonList() {
      let that = this;
      that
        .post(
          "api-apmuc/personHouseRelationRest/queryPersonHouseRelations",
          that.personParams
        )
        .then((res) => {
          that.personList = that.personList.concat(res.data);

          // 加载状态结束
          that.loading = false;

          // 数据全部加载完成
          if (that.personList.length >= res.total) {
            that.finished = true;
          } else {
            that.personParams.page++;
            that.finished = false;
          }
        });
    },
    onSearchName(val) {
      this.personParams.personneName = val;
      this.personParams.page = 1;
      this.personList = [];
      this.onLoad();
    },
    onSearchCard(val) {
      this.personParams.personneCardNo = val;
      this.personParams.page = 1;
      this.personList = [];
      this.onLoad();
    },
    deletePerson(msg, index) {
      let that = this;
      Dialog.confirm({
        title: "提示",
        message: "是否确定删除此条数据?",
      })
        .then(() => {
          that.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "删除中...",
          });
          let params = {
            communityId: msg.communityId,
            houseId: msg.houseId,
            personneId: msg.personneId,
          };
          that
            .post(
              "api-apmuc/personHouseRelationRest/relievePersonHouseRelation",
              params
            )
            .then((res) => {
              that.$toast.clear();
              if (res.resp_code == 0) {
                that.personList.splice(index, 1);
                that.$toast.success("已删除!");
              } else {
                that.$toast.fail("删除失败");
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    editPerson(id) {
      this.$router.push({
        path: "/edit",
        query: {
          token: this.access_token,
          id: id,
          communityId: this.personParams.communityId,
        },
      });
    },
    //下发
    putSyncData(id) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认重新下发？",
      })
        .then(() => {
          this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "下发中...",
          });
          let param = { relationIds: [id] };
          this.post("/apmdev-server/equipmentRest/putSyncData", param).then(
            (res) => {
              console.log("--- res", res);
              this.$toast.clear();
              if (res.resp_code == 0) {
                this.$toast.success("下发成功!");
              } else {
                this.$toast.fail(res.resp_msg || "下发失败!");
              }
            }
          );
        })
        .catch(() => {});
    },
    //下发记录
    gotoPutSyncData(id) {
      this.$router.push({
        path: "/record",
        query: {
          token: this.access_token,
          id: id,
          communityId: this.personParams.communityId,
        },
      });
    },
    onCommunityConfirm(values) {
      this.showCommunityPicker = false;
      this.communityName = values.name;
      this.personParams.communityId = values.id;
      this.personParams.page = 1;
      this.personList = [];
      this.onLoad();
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
  font-size: 18px;
  line-height: 48px;
  background: #eee;
}
.title i {
  vertical-align: text-top;
  margin-left: 6px;
}
.search {
  display: flex;
}
.van-swipe-cell {
  margin-bottom: 10px;
}
.van-card__thumb {
  width: 50px;
  height: 50px;
}
.van-card__content {
  min-height: 0;
  justify-content: center;
}
.van-button--square {
  height: 100%;
}
</style>
